import { sizes } from '@/utils'

import tag from '@/components/tag'

function getItemLabel({ mcc, mnc, country, operator, fullCountry }) {
  if (fullCountry && country) {
    return country
  }

  if (country && operator) {
    return `${country} | ${operator}`
  }

  return `${mcc} | ${mnc}`
}

function renderCount(h) {
  if (this.isMany) {
    return h(
      tag,
      {
        props: {
          label: `+${this.values.length - this.count}`,
          size: sizes.tiny,
          tooltip: this.values.reduce((result, item, index) => {
            if (index < 20) {
              result.push(getItemLabel(item))
            }

            return result
          }, []).join('\n')
        }
      }
    )
  }
}

function renderItem(h, item) {
  const { mcc, mnc } = item
  const label = getItemLabel(item)

  return h(
    tag,
    {
      props: {
        label,
        size: sizes.tiny
      },
      key: `${mcc}:${mnc}`
    }
  )
}

function renderItems(h) {
  return this.values.slice(0, this.count).map(item => {
    return renderItem.call(this, h, item)
  })
}

export default function(h) {
  return h(
    'div',
    {
      class: {
        'routes-conditions__condition-value': true,
        link: this.isMany
      },
      on: {
        click: () => {
          if (this.isMany) {
            this.$emit('click', true)
          }
        }
      }
    },
    [
      renderItems.call(this, h),
      renderCount.call(this, h)
    ]
  )
}
